import { API } from '@api'

export const productFilters = async ({ postType }) => {
  if (!postType) return null
  return await API.ProductFilters.show(postType)
}
